export default {
  // API_ENDPOINT: 'http://localhost:8000/api',
  API_ENDPOINT: 'https://vast-falls-46210.herokuapp.com/api'
}
